module.exports = __webpack_public_path__ + "img/footer-logo-th.a548b744.png";